import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { getIsPlaylistEditable } from 'utils/privileges';
import { checkIsAsset, checkIsPlaylist } from 'types/content/utils';
import EmptyStateController from 'components/EmptyStateController';
import CollectionGrid, { CollectionGridItem } from 'components/CollectionGrid';
import { VerticalCard } from 'components/ContentCards';
import { useCardController } from 'components/ContentCards/controllers';
import useOnWebAssetClick from '../../shared/useOnWebAssetClick';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import { jsx as _jsx } from "react/jsx-runtime";
function ControlledVerticalCard(_ref) {
  var data = _ref.data;
  var content = data.contentItem;
  var isAsset = checkIsAsset(content);
  var _useOnWebAssetClick = useOnWebAssetClick(),
    _onWebAssetClick = _useOnWebAssetClick.onWebAssetClick;
  var contentItem = useCardController(_objectSpread(_objectSpread({}, data), {}, {
    onWebAssetClick: function onWebAssetClick() {
      return _onWebAssetClick({
        type: isAsset ? content.type : undefined,
        markAsDoneMode: isAsset ? content.markAsDoneMode : undefined,
        userContentStatus: content.userContentStatus,
        contentId: content.id
      });
    }
  }));

  // Define the VerticalCard image source
  contentItem.imageSource = getPictureUrl({
    id: content.thumbnailId,
    dimensions: DIMENSIONS.VERTICAL_CARD
  });
  return /*#__PURE__*/_jsx(VerticalCard, _objectSpread({}, contentItem));
}
function ItemsGrid(_ref2) {
  var items = _ref2.items,
    isError = _ref2.isError,
    isLoading = _ref2.isLoading,
    emptyContent = _ref2.emptyContent,
    _ref2$priorityPillTyp = _ref2.priorityPillType,
    priorityPillType = _ref2$priorityPillTyp === void 0 ? 'goal' : _ref2$priorityPillTyp;
  return /*#__PURE__*/_jsx(EmptyStateController, {
    isEmpty: !items || items.length === 0,
    emptyContent: items && emptyContent,
    isError: isError,
    isLoading: isLoading,
    children: /*#__PURE__*/_jsx(CollectionGrid, {
      children: items === null || items === void 0 ? void 0 : items.map(function (item) {
        var isPlaylist = checkIsPlaylist(item);
        var isEditablePlaylist = isPlaylist && getIsPlaylistEditable({
          playlist: item
        });
        var contentItemData = {
          contentItem: item,
          priorityPillType: priorityPillType,
          collectionId: isPlaylist ? item.id : undefined,
          isEditablePlaylist: isEditablePlaylist,
          canRemoveFromPlaylist: false
        };
        return /*#__PURE__*/_jsx(CollectionGridItem, {
          large: true,
          children: /*#__PURE__*/_jsx(ControlledVerticalCard, {
            data: contentItemData
          })
        }, item.id);
      })
    })
  });
}
export default ItemsGrid;